<template>
  <div class="t-lk-header-notify">
    <div class="t-lk-header-notify__container" @click="openModalDropdown">
      <div
        v-if="profile.notifications && profile.notifications.length > 0"
        class="t-lk-header-notify__number"
      >
        {{ profile.notifications.length > 99 ? '99+' : profile.notifications.length }}
      </div>
      <svg class="t-lk-header-notify__svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0203 3.0203C10.5454 2.49519 11.2576 2.2002 12.0002 2.2002C12.7428 2.2002 13.455 2.49519 13.9801 3.0203C14.4574 3.49756 14.7446 4.12937 14.7929 4.7981C15.8962 5.2953 16.8503 6.07953 17.5527 7.07332C18.3645 8.22183 18.8004 9.59375 18.8002 11.0002C18.8002 11.0002 18.8002 11.0002 18.8002 11.0002V14.1582C18.8002 14.32 18.832 14.4803 18.8939 14.6298C18.9558 14.7793 19.0466 14.9152 19.161 15.0296L20.5659 16.4345C20.7947 16.6633 20.8631 17.0074 20.7393 17.3063C20.6155 17.6053 20.3238 17.8002 20.0002 17.8002H15.8002V18.0002C15.8002 19.008 15.3999 19.9746 14.6872 20.6872C13.9746 21.3998 13.008 21.8002 12.0002 21.8002C10.9924 21.8002 10.0259 21.3998 9.31321 20.6872C8.60057 19.9746 8.20022 19.008 8.20022 18.0002V17.8002H4.00022C3.67665 17.8002 3.38494 17.6053 3.26112 17.3063C3.13729 17.0074 3.20573 16.6633 3.43453 16.4345L4.83953 15.0295C5.07052 14.7985 5.20022 14.485 5.20022 14.1592V11.0002C5.20022 8.23929 6.84602 5.86376 9.20751 4.79822C9.25585 4.12945 9.54303 3.49759 10.0203 3.0203ZM9.80022 17.8002V18.0002C9.80022 18.5837 10.032 19.1432 10.4446 19.5558C10.8572 19.9684 11.4167 20.2002 12.0002 20.2002C12.5837 20.2002 13.1433 19.9684 13.5559 19.5558C13.9684 19.1432 14.2002 18.5837 14.2002 18.0002V17.8002H9.80022ZM18.0688 16.2002L18.0295 16.1609C17.7666 15.8979 17.5579 15.5856 17.4156 15.2419C17.2734 14.8983 17.2002 14.5301 17.2002 14.1582C17.2002 14.1582 17.2002 14.1582 17.2002 14.1582V11.0002C17.2003 9.92455 16.867 8.87522 16.2462 7.99685C15.6253 7.11848 14.7474 6.45417 13.7334 6.09538C13.4138 5.98232 13.2002 5.68015 13.2002 5.3412V5.0002C13.2002 4.68194 13.0738 4.37671 12.8487 4.15167C12.6237 3.92662 12.3185 3.8002 12.0002 3.8002C11.682 3.8002 11.3767 3.92662 11.1517 4.15167C10.9266 4.37671 10.8002 4.68194 10.8002 5.0002V5.3412C10.8002 5.6802 10.5866 5.98239 10.2669 6.09542C8.24644 6.80997 6.80022 8.7378 6.80022 11.0002V14.1592C6.80022 14.9094 6.50192 15.6299 5.9709 16.1609L5.93159 16.2002H18.0688Z" fill="white"/>
      </svg>
    </div>

    <div
      v-if="profile.notifications && profile.notifications.length > 0 && !isMobile"
      class="t-lk-header-notify-dropdown"
      :class="{'_after': isAfter}"
    >
      <div class="t-lk-header-notify-dropdown__wrap">
        <div class="t-lk-header-notify-dropdown__head">
          <div class="t-lk-header-notify-dropdown__title">
            {{ profile.notifications.length > 99 ? '99+' : profile.notifications.length }}
            {{ $root.staticText.lk.notify }}
          </div>
          <router-link :to="{name: 'lk-notifications'}" class="t-main-head__all t-lk-link">
            <span>{{ $root.staticText.lk.notifyAll }}</span>
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.8396 3.93238C5.60815 4.16383 5.60815 4.53908 5.8396 4.77053L9.56918 8.50011L5.8396 12.2297C5.60815 12.4611 5.60815 12.8364 5.8396 13.0678C6.07105 13.2993 6.44631 13.2993 6.67776 13.0678L10.8264 8.91918C11.0579 8.68774 11.0579 8.31248 10.8264 8.08103L6.67776 3.93238C6.44631 3.70093 6.07105 3.70093 5.8396 3.93238Z" fill="#00b0bd"/>
            </svg>
          </router-link>
        </div>
        <div class="t-lk-header-notify-dropdown__container js-dropdown-notify">
          <div v-for="item in profile.notifications" class="t-lk-header-notify-dropdown__item">
            <div class="t-lk-header-notify-dropdown__row">
              <div class="t-lk-header-notify-dropdown__tag">{{ item.tag }}</div>
              <div class="t-lk-header-notify-dropdown__date">
                {{ item.date }}
                <svg class="t-lk-header-notify-dropdown__svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00013 2.53322C6.55028 2.53322 5.15981 3.10917 4.13461 4.13437C3.10941 5.15957 2.53346 6.55004 2.53346 7.99989C2.53346 8.71778 2.67486 9.42864 2.94959 10.0919C3.22431 10.7551 3.62699 11.3578 4.13461 11.8654C4.64224 12.373 5.24488 12.7757 5.90813 13.0504C6.57137 13.3252 7.28224 13.4666 8.00013 13.4666C8.71802 13.4666 9.42889 13.3252 10.0921 13.0504C10.7554 12.7757 11.358 12.373 11.8656 11.8654C12.3733 11.3578 12.7759 10.7551 13.0507 10.0919C13.3254 9.42864 13.4668 8.71778 13.4668 7.99989C13.4668 6.55004 12.8908 5.15957 11.8656 4.13437C10.8404 3.10917 9.44998 2.53322 8.00013 2.53322ZM3.38037 3.38012C4.6056 2.15488 6.26738 1.46655 8.00013 1.46655C9.73288 1.46655 11.3947 2.15488 12.6199 3.38012C13.8451 4.60536 14.5335 6.26714 14.5335 7.99989C14.5335 8.85786 14.3645 9.70742 14.0361 10.5001C13.7078 11.2927 13.2266 12.013 12.6199 12.6196C12.0132 13.2263 11.293 13.7076 10.5003 14.0359C9.70767 14.3642 8.8581 14.5332 8.00013 14.5332C7.14216 14.5332 6.29259 14.3642 5.49993 14.0359C4.70727 13.7076 3.98704 13.2263 3.38037 12.6196C2.77369 12.013 2.29245 11.2927 1.96412 10.5001C1.63579 9.70742 1.4668 8.85786 1.4668 7.99989C1.4668 6.26714 2.15513 4.60536 3.38037 3.38012ZM8.00013 4.79989C8.29468 4.79989 8.53346 5.03867 8.53346 5.33322V7.77897L10.3773 9.62276C10.5855 9.83104 10.5855 10.1687 10.3773 10.377C10.169 10.5853 9.83129 10.5853 9.62301 10.377L7.62301 8.37701C7.52299 8.27699 7.4668 8.14134 7.4668 7.99989V5.33322C7.4668 5.03867 7.70558 4.79989 8.00013 4.79989Z" fill="#C0C0CC"/>
                </svg>
              </div>
            </div>
            <div class="t-lk-header-notify-dropdown__name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./style.sass"
import { mapGetters, mapState, mapActions } from "vuex"
import BellSvg from "@assets/lk/img/Bell.svg?inline"
import CloseSvg from "@assets/lk/img/Close.svg?inline"

export default {
  name: "lk-notification",
  components: { BellSvg, CloseSvg },
  data() {
    return {
      isAfter: true,
      isDropdownOpen: false,
      elemDropdown: null,
      openDropdown: false,
    }
  },
  computed: {
    ...mapGetters("lk", ["profile"]),
    ...mapState("mobile", ["isMobileMenuVisible", "isTabletMenuVisible", "isMobile", 'isTabletHeader']),

    countNotifications() {
      if (!this.profile.notifications.length) return ""
      return this.profile.notifications.length > 99 ? "99+" : String(this.profile.notifications.length).padStart(2, " ")
    },
    isBurgerActive() {
      return this.isMobileMenuVisible || this.isTabletMenuVisible
    },
  },
  methods: {
    ...mapActions("modal", ["modalType_lkMobileNotifyOpen"]),

    mounted() {
      setTimeout(() => {
        this.elemDropdown = document.querySelector('.js-dropdown-notify')
        if (this.elemDropdown) {
          this.scrollBlock()
          this.elemDropdown.addEventListener('scroll', this.scrollBlock)
        }
      }, 100)
    },
    beforeDestroy() {
      if (this.elemDropdown) {
        this.elemDropdown.removeEventListener('scroll', this.scrollBlock)
      }
    },
    openModalDropdown() {
      if (this.isMobile) {
        if (this.profile.notifications.length > 0) {
          this.modalType_lkMobileNotifyOpen({})
        } else {
          this.$router.push({ name: "lk-notifications" })
        }
      } else {
        this.$router.push({ name: "lk-notifications" })
      }
    },
    scrollBlock() {
      let end = this.elemDropdown.scrollHeight - this.elemDropdown.clientHeight
      this.isAfter = this.elemDropdown.scrollTop < end
    },
    closeDropdown() {
      this.openDropdown = false
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-header/notifications/index.vue